import { Box, Typography } from '@material-ui/core'

import { useAppSelector } from 'store'

import { PremiumWrapper } from '../components/PremiumPreview/PremiumWrapper'
import DataPointsGrid from './DataPointsGrid'
import { HighschoolData } from './useGetHighschoolPreviewData'

const DemographicsDetails = ({ highschool }: { highschool: HighschoolData }) => {
  const isPremiumExplorerEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsPremiumHighSchoolExplorer || false,
  )
  if (!highschool) return null
  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Typography variant="h6">Demographics</Typography>
      <PremiumWrapper
        enabled={isPremiumExplorerEnabled}
        trackingIdPlacement="demographics-details"
      >
        <DataPointsGrid
          dataPoints={[
            {
              title: '% First Generation',
              data: highschool.pctFirstGenerationStudents ? `${highschool.pctFirstGenerationStudents}%` : undefined,
              isPremium: true,
            },
          ]}
        />
        <Typography variant="subtitle2">Race and Ethnicity</Typography>
        <DataPointsGrid
          dataPoints={[
            {
              title: '% Asian',
              data: highschool.pctAsianStudents ? `${highschool.pctAsianStudents}%` : undefined,
              isPremium: true,
            },
            {
              title: '% Black/African American',
              data: highschool.pctBlackAfricanAmericanStudents
                ? `${highschool.pctBlackAfricanAmericanStudents}%`
                : undefined,
              isPremium: true,
            },
            {
              title: '% Hispanic/Latino',
              data: highschool.pctHispanicLatinoStudents ? `${highschool.pctHispanicLatinoStudents}%` : undefined,
              isPremium: true,
            },
            {
              title: '% Native American',
              data: highschool.pctNativeAmericanStudents ? `${highschool.pctNativeAmericanStudents}%` : undefined,
              isPremium: true,
            },
            {
              title: '% White/Caucasian',
              data: highschool.pctWhiteCaucasianStudents ? `${highschool.pctWhiteCaucasianStudents}%` : undefined,
              isPremium: true,
            },
          ]}
        />
      </PremiumWrapper>
    </Box>
  )
}

export default DemographicsDetails
